module.exports = __webpack_public_path__ + "static/media/grid-main-image.ce98fa6b.png";